import { apiRequest } from '../api/client';

/** Matches `apps/api` `StoredWithholdingTypeWithUsage` (`withholding-type.repository.ts`). */
export interface WithholdingType {
  id: string;
  name: string;
  jurisdiction: string | null;
  /** Percentage (3.5 means 3,5 %). */
  defaultRatePercent: number | null;
  isActive: boolean;
  withholdingUsageCount: number;
  createdAt: string;
  updatedAt: string;
}

/** Matches `apps/api` `GET /withholding-types` (`settings.manage`). */
export function listWithholdingTypes(): Promise<WithholdingType[]> {
  return apiRequest<WithholdingType[]>('/withholding-types');
}

/** Matches `apps/api` `WithholdingTypeOption` (`list-withholding-types.use-case.ts`). */
export interface WithholdingTypeOption {
  id: string;
  name: string;
  jurisdiction: string | null;
  defaultRatePercent: number | null;
}

/** Matches `apps/api` `GET /withholding-types/options` (`payment.register`; active types only). */
export function listWithholdingTypeOptions(): Promise<WithholdingTypeOption[]> {
  return apiRequest<WithholdingTypeOption[]>('/withholding-types/options');
}

export interface CreateWithholdingTypeInput {
  name: string;
  jurisdiction?: string | null;
  defaultRatePercent?: number | null;
  isActive?: boolean;
}

/** Matches `apps/api` `POST /withholding-types`. */
export function createWithholdingType(input: CreateWithholdingTypeInput): Promise<WithholdingType> {
  return apiRequest<WithholdingType>('/withholding-types', {
    method: 'POST',
    body: JSON.stringify(input),
  });
}

/** `null` clears the jurisdiction or the default rate; omitting a field leaves it untouched. */
export type UpdateWithholdingTypeInput = Partial<CreateWithholdingTypeInput>;

/** Matches `apps/api` `PATCH /withholding-types/:id`. */
export function updateWithholdingType(
  id: string,
  input: UpdateWithholdingTypeInput,
): Promise<WithholdingType> {
  return apiRequest<WithholdingType>(`/withholding-types/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(input),
  });
}
